import { env } from '../config/env';

export const shouldUseIndexedServerUrls = !env.debug && env.appEnv !== 'dynamic';
